import { showMessage } from '@queries/showMessage';
import { $api } from '@service/RequestService';
import { useMutation, useQueryClient } from 'react-query';

import { crmConstants } from '..';

export const usePipeSave = () => {
  const qc = useQueryClient();

  return useMutation(
    async (data: any) => {
      const res = await $api.post('/v1/pipe', data);

      return res?.data;
    },
    {
      onSuccess: async (data: any) => {
        await qc.invalidateQueries({ queryKey: [crmConstants.queryKeys.PIPE_ALL] });
        showMessage(data.message, data.accept);
      }
    }
  );
};
